import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LiveEnquiriesComponent } from '../biddings/live-enquiries/live-enquiries.component';
import { PastEnquiriesComponent } from '../biddings/past-enquiries/past-enquiries.component';
import { ActivePurchaseOrderComponent } from '../purchase-order/active-purchase-order/active-purchase-order.component';
import { PendingPurchaseOrderComponent } from '../purchase-order/pending-purchase-order/pending-purchase-order.component';
interface DialogData {
    page: '',
    data: {
      model_attributes: {
        model_file_url: ''
      }
    }
}

@Component({
  selector: 'app-pdf-viewer-popup',
  templateUrl: './pdf-viewer-popup.component.html',
  styleUrls: ['./pdf-viewer-popup.component.scss']
})
export class PdfViewerPopupComponent implements OnInit {
  pdfSrc: any;
  pagevariable: number;
  @ViewChild('myPinch') myPinch;
  thumbnail = [];
  fromPage = 1;
  outputtotalpages: any;
  fromPagePopup: string;
  constructor( private dialogRefPendingPo: MatDialogRef<PendingPurchaseOrderComponent>, private dialogRefActivePo: MatDialogRef<ActivePurchaseOrderComponent>, private dialogRef1: MatDialogRef<PastEnquiriesComponent>, private dialogRef: MatDialogRef<LiveEnquiriesComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit(): void {
    this.pagevariable = 1;
    this.fromPagePopup = this.data.page;
    this.pdfSrc = this.data.data.model_attributes.model_file_url;
  }

  previousPage() {
    if (this.fromPage < this.pagevariable) {
      const temppage = Number(this.pagevariable) - 1;
      setTimeout(() => {
        if (temppage !== 0) {
          this.pagevariable = temppage;
        }
      }, 100);
    }
  }

  nextPage() {
    if (this.outputtotalpages > this.pagevariable) {
      const temppage = Number(this.pagevariable) + 1;
      setTimeout(() => {
        if (temppage !== 0) {
          this.pagevariable = temppage;
        }
      }, 100);
    }
  }

  zoomin() {
    this.myPinch.toggleZoom();
  }
  zoomout() {
    this.myPinch.toggleZoom();
  }

  afterLoadComplete(pdf: any) {
    setTimeout(() => {
      this.outputtotalpages = pdf.numPages;
    }, 100);
  }

  pageRendered($event: any) {    
    this.thumbnail.push({
      page: $event.pageNumber,
      url: $event.source.canvas.toDataURL()
    })
    console.log("this.thumbnail",this.thumbnail)
  }

  close() {
    if(this.fromPagePopup == 'liveEnquiry') {
      this.dialogRef.close()
    } else if(this.fromPagePopup == 'pastEnquiry') {
      this.dialogRef1.close()
    } else if(this.fromPagePopup == 'activePo') {
      this.dialogRefActivePo.close()
    } else if(this.fromPagePopup == 'pendingPo') {
      this.dialogRefPendingPo.close()
    } 
   
  }

}